import React from "react";
// Replaced lucide-react with react-icons imports
import { MdOutlineMail, MdPhone, MdOutlineWeb } from "react-icons/md";
import { FaLinkedinIn, FaTwitter, FaFileAlt } from "react-icons/fa";
import Employee from "../../assets/employeeimg.png";
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from "react-icons/ai";

const CandidateDetails = () => {
  const candidate = {
    name: "Cheryl Temiloluwa",
    email: "cheree@gmail.com",
    phone: "+234 901 222 3333",
    employeeId: "CEPH/OGBM/24/001",
    status: "Interviewed",
    appliedOn: "21st March, 2025",
    score: 75,
    scoreText: "Potential Fit",
    profilePictureUrl: Employee,
    expectedSalary: "3.6 million (NGN)",
    availableDate: "15th April, 2024",
    experience: [
      {
        title: "Senior Data Analyst",
        company: "Google",
        duration: "(Dec 2021 - Present)",
        responsibilities: [
          "Data Exploration and Analysis: They perform exploratory data analysis to uncover insights, trends, and patterns in the data, often using statistical and visualisation techniques.",
          "Data Cleaning and Preprocessing: Data analysts are responsible for cleaning and preparing raw renewable data to ensure its accuracy and reliability for analysis.",
          "Reporting and Communication: Data analysts communicate their findings through reports, dashboards, and presentations to help stakeholders make informed decisions based on the data-driven insights.",
        ],
      },
      {
        title: "Junior Data Analyst",
        company: "Microsoft",
        duration: "(May 2020 - May 2021)",
        responsibilities: [
          "Data Exploration and Analysis: They perform exploratory data analysis to uncover insights, trends, and patterns in the data, often using statistical and visualisation techniques.",
          "Data Cleaning and Preprocessing: Data analysts are responsible for cleaning and preparing raw renewable data to ensure its accuracy and reliability for analysis.",
          "Reporting and Communication: Data analysts communicate their findings through reports, dashboards, and presentations to help stakeholders make informed decisions based on the data-driven insights.",
        ],
      },
    ],
    scoreBreakdown: [
      { label: "Qualifications and Skills", matched: true },
      { label: "Experience Relevance", matched: true },
      { label: "Education", matched: true },
      { label: "Keywords Match", matched: false },
      { label: "Years of Experience", matched: true },
      { label: "Interview Performance", matched: true },
      { label: "Cultural Fit", matched: true },
    ],
  };

  const ScoreListItem = ({ label, matched }) => (
    <div className="flex justify-between items-center py-2 border-b border-gray-100 last:border-b-0">
      <span className="text-gray-600 text-sm">{label}</span>

      {matched ? (
        <AiOutlineCheckCircle className="text-green-500 h-5 w-5" />
      ) : (
        <AiOutlineCloseCircle className="text-red-500 h-5 w-5" />
      )}
    </div>
  );

  // Helper component for experience details
  const ExperienceSection = ({ experience }) => (
    <div>
      <h3 className="text-lg font-semibold text-gray-800">
        {experience.title}
      </h3>
      <p className="text-sm font-medium text-gray-700">
        {experience.company}{" "}
        <span className="text-gray-500">{experience.duration}</span>
      </p>
      <p className="mt-2 text-sm font-semibold text-gray-700">
        Responsible for:
      </p>
      <ol className="list-decimal list-inside ml-2 space-y-1 text-xs text-gray-600">
        {experience.responsibilities.map((r, index) => (
          <li
            key={index}
            className="pl-1 leading-relaxed"
          >
            {r}
          </li>
        ))}
      </ol>
    </div>
  );

  return (
    <div className="p-6 ">
      <h1 className=" text-[#000000] mb-6 text-lg font-semibold font-Nunito">
        Recruitment
      </h1>
      <div className="w-full mx-auto  rounded-xl p-8 border bg-white font-Nunito">
        <h1 className="text-xl font-bold mb-4 text-[#000000]">
          Candidate's Details
        </h1>

        <div>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
            <div className="md:col-span-8">
              <div className="flex bg-[#F3F8FF] rounded-xl    flex-col sm:flex-row items-start space-y-4 sm:space-y-0 sm:space-x-6 p-6 border-b border-gray-200">
                <div className="relative w-40 h-40 flex-shrink-0">
                  <img
                    src={candidate.profilePictureUrl}
                    alt={candidate.name}
                    className="rounded-full object-cover w-full h-full border-4 border-white shadow-md"
                  />
                </div>

                <div className="flex-grow">
                  <h2 className="text-2xl font-bold text-[black]">
                    {candidate.name}
                  </h2>

                  <div className="flex items-center space-x-3 mt-1 text-sm text-blue-600">
                    <MdOutlineMail className="h-4 w-4" />
                    <a
                      href={`mailto:${candidate.email}`}
                      className="hover:underline"
                    >
                      {candidate.email}
                    </a>
                    <span className="text-gray-300">|</span>
                    <MdPhone className="h-4 w-4" />
                    <span className="text-gray-600">{candidate.phone}</span>
                    <span className="text-gray-300">|</span>
                    <a
                      href="#"
                      className="hover:text-blue-800"
                    >
                      <FaLinkedinIn className="h-4 w-4" />
                    </a>
                    <a
                      href="#"
                      className="hover:text-blue-800"
                    >
                      <FaTwitter className="h-4 w-4" />
                    </a>
                    <a
                      href="#"
                      className="hover:text-blue-800"
                    >
                      <MdOutlineWeb className="h-4 w-4" />
                    </a>
                  </div>

                  {/* Status and ID (unchanged) */}
                  <p className="mt-3 text-base">
                    <span className="font-semibold text-[#071C50]">
                      Employee ID:
                    </span>
                    <span className="text-[#071C50] font-semibold">
                      {candidate.employeeId}
                    </span>
                  </p>
                  <div className="flex items-center space-x-4 text-sm mt-1">
                    <div className="flex items-center">
                      <span className="font-semibold text-gray-700 mr-2">
                        Status:
                      </span>
                      <span className="px-3 py-1 bg-[#DDEAFB] text-[#071C50] rounded-full font-medium">
                        {candidate.status}
                      </span>
                    </div>
                    <div className="flex items-center">
                      <span className="font-semibold text-[#071C50] mr-2">
                        Applied On:
                      </span>
                      <span className="text-[#071C50]">
                        {candidate.appliedOn}
                      </span>
                    </div>
                  </div>

                  {/* Documents (Updated to react-icons) */}
                  <div className="flex space-x-4 mt-4">
                    <a
                      href="#"
                      className="flex items-center p-4 bg-[#F4F4F8] border border-[#071C5026] text-red-700 text-sm rounded-lg hover:bg-red-100 transition"
                    >
                      <FaFileAlt className="h-4 w-4 mr-2" />
                      <span>Cover_letter.pdf</span>
                      <span className="ml-2 text-sm text-red-500">2d ago</span>
                    </a>
                    <a
                      href="#"
                      className="flex items-center p-4 bg-green-50 border border-[#071C5026] text-[#071C50] text-sm rounded-lg hover:bg-green-100 transition"
                    >
                      <FaFileAlt className="h-4 w-4 mr-2" />
                      <span>My_resume.pdf</span>
                      <span className="ml-2 text-sm text-green-500">
                        2d ago
                      </span>
                    </a>
                  </div>
                </div>
              </div>

              <div className="mt-6 space-y-6">
                <h3 className="text-lg font-bold text-gray-800">
                  Last Experience
                </h3>
                {candidate.experience.map((exp, index) => (
                  <ExperienceSection
                    key={index}
                    experience={exp}
                  />
                ))}
              </div>

              <div className="mt-8 pt-4 border-t border-gray-200 flex space-x-8 text-sm">
                <div>
                  <p className="font-semibold text-gray-700">
                    Expected Salary (Annual)
                  </p>
                  <p className="text-blue-600 font-bold text-lg mt-1">
                    {candidate.expectedSalary}
                  </p>
                </div>
                <div>
                  <p className="font-semibold text-gray-700">
                    Available date to start
                  </p>
                  <p className="text-gray-600 font-medium text-lg mt-1">
                    {candidate.availableDate}
                  </p>
                </div>
              </div>
            </div>

            <div className="md:col-span-4 p-6 space-y-8  border-l bg-[#F3F8FF] rounded-xl ">
              <div className="flex flex-col items-center p-4 w-72 mx-auto bg-white border border-gray-200 rounded-xl shadow-inner">
                <div className="relative w-24 h-24">
                  <div
                    className="w-full h-full rounded-full border-[6px] border-gray-200"
                    style={{
                      background: `conic-gradient(#10B981 ${
                        (candidate.score / 100) * 360
                      }deg, #E5E7EB 0deg)`,
                    }}
                  >
                    <div className="absolute inset-2 bg-white rounded-full flex flex-col items-center justify-center">
                      <span className="text-2xl font-bold text-green-600">
                        {candidate.score}
                      </span>
                    </div>
                  </div>
                </div>
                <p className="mt-3 text-lg font-semibold text-green-600">
                  Score:
                </p>
                <p className="text-xl font-bold text-gray-800">
                  {candidate.scoreText}
                </p>
              </div>

              <div className="mt-6">
                {candidate.scoreBreakdown.map((item, index) => (
                  <ScoreListItem
                    key={index}
                    label={item.label}
                    matched={item.matched}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateDetails;
